import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import api, { fmtErr } from "../lib/api";
import { toast } from "sonner";

export default function SetPassword() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password.length < 8) return setError("New password must be at least 8 characters");
    if (form.new_password !== form.confirm) return setError("New passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password updated — welcome back!");
      navigate("/app", { replace: true });
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:border-shipany-blue focus:outline-none";

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4" data-testid="set-password-page">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <img src="/logo.png" alt="ShipAny" className="h-10 w-auto" />
        <div className="mt-6">
          <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-50">
            <ShieldCheck className="h-6 w-6 text-shipany-blue" />
          </span>
          <h1 className="font-display mt-4 text-xl font-bold text-shipany-navy">Set your new password</h1>
          <p className="mt-2 text-sm leading-relaxed text-slate-500">
            You signed in with a temporary password. Choose your own password now to secure your account.
          </p>
          <form onSubmit={submit} className="mt-5 space-y-3.5">
            <input data-testid="set-current-password-input" type="password" required value={form.current_password}
              onChange={(e) => setForm({ ...form, current_password: e.target.value })}
              placeholder="Temporary password (from WhatsApp)" className={`${inputCls} mono`} />
            <input data-testid="set-new-password-input" type="password" required value={form.new_password}
              onChange={(e) => setForm({ ...form, new_password: e.target.value })}
              placeholder="New password (min 8 chars)" className={inputCls} />
            <input data-testid="set-confirm-password-input" type="password" required value={form.confirm}
              onChange={(e) => setForm({ ...form, confirm: e.target.value })}
              placeholder="Confirm new password" className={inputCls} />
            {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-xs font-medium text-red-600" data-testid="set-password-error">{error}</p>}
            <button data-testid="set-password-submit-btn" disabled={loading}
              className="flex w-full items-center justify-center gap-2 rounded-xl bg-shipany-blue py-3 text-sm font-bold text-white transition-colors hover:bg-[#0648B3] disabled:opacity-60 glow-blue">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />}
              Set new password
            </button>
          </form>
          <p className="mt-5 text-center text-sm text-slate-500">
            <Link to="/login" data-testid="set-password-goto-login" className="font-semibold text-shipany-blue hover:underline">Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
